export default (mutation) => {
  const firstnameMatches = window.location.hash.match(/pageData\[{1,2}[^[\]]*name=([^\]]+)\]{1,2}/);
  const firstname = firstnameMatches ? firstnameMatches[1] : null;
  const elementsToPersonalize = [
    '.wp-block-animalequality-pattern-simple p',
    '.wp-block-animalequality-pattern-hero h1',
    '.wp-block-animalequality-pattern-hero p'
  ];

  if (mutation.type !== 'childList' || !mutation.target.matches || !mutation.target.matches(elementsToPersonalize.join(','))) {
    return;
  }

  const regex = /{{firstname or \[(.*?)\]}}/g;
  const placeholders = mutation.target.textContent.match(regex);

  if (!placeholders) {
    return;
  }

  placeholders.forEach(placeholder => {
    const fallback = placeholder.match(/\[(.*)\]/);

    if (firstname || (fallback && fallback.length && fallback[1])) {
      mutation.target.textContent = mutation.target.textContent.replace(placeholder, firstname ? decodeURIComponent(firstname) : fallback[1]);
    }
  });
};
